.swap { display: flex; flex-wrap: wrap; align-items: center; gap: 10px 20px; padding: 12px 16px; background: var(--paper-2); border: var(--border-hair); }
.why { flex: 1 1 100%; margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--text-secondary); }
.flag { color: var(--hot); }
.alternative { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; min-width: 0; }
.label { font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--ink); }
.quiet { font-family: var(--font-cond); font-size: 18px; font-weight: 900; letter-spacing: -0.5px; line-height: 1; color: var(--text-secondary); }
.structure { font-size: 13px; color: var(--ink); }
.actions { display: flex; gap: 10px; margin-left: auto; }
.keep, .swapButton { display: inline-flex; align-items: center; justify-content: center; height: 36px; padding: 0 14px; border: var(--border-control); font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--ink); white-space: nowrap; }
.keep { background: var(--paper); }
.swapButton { background: var(--pink); }
.swapButton:disabled { opacity: 0.5; cursor: progress; }

@media (max-width: 639px) {
  .swap { flex-direction: column; flex-wrap: nowrap; align-items: stretch; padding: 10px 12px; }
  .actions { margin-left: 0; }
  .keep, .swapButton { flex: 1; height: 44px; }
}
